/**
 * Central API endpoint paths. Use in api/*.js modules with serviceClient / getApiClient.
 * Functions return path + optional query string so URLs stay in one place.
 */
export const ENDPOINTS = {
  OBJECTS: {
    RECENT: () => "api/DocumentManagement/get-recentobjects",
  },
  CHECKIN: {
    DOCUMENT: () => "api/DocumentManagement/check-in",
    DOCUMENT_CHUNKED: () => "api/DocumentManagement/check-in/upload",
    DOCUMENTS_BULK: () => "api/DocumentManagement/check-in/check-in-bulk",
    DOCUMENT_EXISTING: () => "api/DocumentManagement/check-in-existing",
  },
  CHECKOUT: {
    DOCUMENT: () => "api/DocumentManagement/check-out",
    DOCUMENTS_BULK: () => "api/DocumentManagement/check-out/check-out-bulk",
    UNDO_DOCUMENTS_BULK: () =>
      "api/DocumentManagement/check-out/undo-check-out-bulk",
  },
  /** OneDrive/Teams document list (check-in new list, working docs list). */
  ONEDRIVE: {
    DOCS: () => "api/OneDrive/get-onedrive-docs",
    SHARING_DETAILS: () => "api/OneDrive/get-onedrive-sharing-details",
    STOP_SHARING: () => "api/OneDrive/stop-onedrive-sharing",
    VERSION_HISTORY: () => "api/OneDrive/get-onedrive-version-history",
  },
  DOCUMENTS: {
    SEARCH: () => "api/search-documents",
    RECENT: () => "api/get-recent-documents",
    MERGE_EXPORT: () => "api/merge-export-documents",
  },
  CHANNEL: {
    CONFIGS: () => "api/Channel/get-channel-configs",
  },
  AUTH: {
    CUSTOMER_CONFIG: () => "api/Customer/get-customerconfig",
  },
};
